// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"5f6c2da1","454":"aa1e0439"}[chunkId] + ".chunk.js";
};